import React, { FC } from 'react'

import { pluralize } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'
import { InputBasedFilter } from './FiltersVariations/Input'

interface MinOccupancyFilterProps extends FiltersSharedProps {
  label: string
  activeValue?: string
  initialValue?: string
  onChange: (value?: string) => void
}

export const MinOccupancyFilter: FC<MinOccupancyFilterProps> = ({
  label,
  activeValue,
  ...props
}) => (
  <InputBasedFilter
    title={label}
    placeholder="0"
    type="number"
    tagSuffix={activeValue ? pluralize(parseInt(activeValue, 2), 'guests', 'guest') : undefined}
    {...props}
  />
)
